import ChangeLessonModal from './ChangeLessonModal';

export default ChangeLessonModal;
